import React, { useCallback } from 'react'
import {
  BooleanInput,
  SimpleForm,
  TextInput,
  email,
  required,
  useCreate,
  useNotify,
  useRedirect,
} from 'react-admin'
import { Grid } from '@mui/material'
import { emailPattern } from '../../utils/validators'
import { CreateBase } from '../../components/base'
import { EMAILCONFIG_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import { BranchMultiSelectInput, FormBottomToolbarWithPermission } from '../../components/form'

const EmailConfigCreate: React.FC = () => {
  const notify = useNotify()
  const redirect = useRedirect()
  const onError = useCallback(
    (error): void => {
      if (error.response.data.code === '23505'){
        return notify('ra.validation.create_email_config_duplicate' || 'ra.validation.create_email_config_fail', { type: 'error' })
      }
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'ra.validation.create_email_config_fail', { type: 'error' })
    },
    [notify],
  )
  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.create_email_config_success', { type: 'success' })
    redirect('/emailconfig')
  }, [notify, redirect])
  const [create] = useCreate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    // email.branch_ids = accessBranches
    create('emailconfig', { data })
  }
  return (
    <CreateBase
      title={'resources.emailconfig.create.title'}
      listAction={{
        hasBackButton: true,
      }}
    >
      <SimpleForm onSubmit={handleSubmit} toolbar={<FormBottomToolbarWithPermission />}>
        <Grid container spacing={1} justifyContent='center'>
          <Grid container item spacing={3} xs={12} sm={8} md={7}>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='first_name'
                label={`${EMAILCONFIG_FIELDS}.first_name`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='last_name'
                label={`${EMAILCONFIG_FIELDS}.last_name`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                source='email'
                type='email'
                label={`${EMAILCONFIG_FIELDS}.email`}
                fullWidth
                validate={[required(), email('ra.validation.invalid_email'), emailPattern()]}
              />
            </Grid>
            <Grid item xs={12}>
              <BranchMultiSelectInput source='branches' validate={[required()]} />
            </Grid>
            <Grid item>
              <BooleanInput
                color='primary'
                source='is_active'
                label={`${COMMON_FIELDS}.status.label`}
              />
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </CreateBase>
  )
}
export default EmailConfigCreate
